import type { AcknowledgeModalProps } from './acknowledge-modal.types'
import { Button } from '../button'
import success from '../../assets/success.json'
import error from '../../assets/error.json'
import { Heading } from '../heading'
import { Text } from '../text'
import styled from 'styled-components'
import { LottieWrapper } from '../LottieWrapper/LottieWrapper'

const AnimationContainer = styled.div`
  display: flex;
  width: 140px;
  height: 100px;
  padding: 0px;
`

export const SuccessIcon = (
  <AnimationContainer data-testid="animation-container">
    <LottieWrapper
      testId="success-animation"
      animationData={success}
      width={150}
      height={140}
    />
  </AnimationContainer>
)

export const ErrorIcon = (
  <AnimationContainer data-testid="animation-container">
    <LottieWrapper
      testId="error-animation"
      animationData={error}
      width={150}
      height={140}
    />
  </AnimationContainer>
)

export const AcknowledgeModal = ({
  result,
  title,
  description,
  buttonText,
  handleClose,
  buttonTestId,
  children,
  secondaryButtonText,
  onSecondaryButtonClick,
  viewTestId = 'acknowledge-modal',
  buttonShape,
}: AcknowledgeModalProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        padding: '32px',
      }}
      data-testid={viewTestId}
    >
      <div data-testid="modal-title">
        {result === 'positive' ? SuccessIcon : ErrorIcon}
      </div>
      <Heading level={'h2'} align="center">
        {title}
      </Heading>
      <span data-testid="modal-description" style={{ textAlign: 'center' }}>
        {children || <Text size="small">{description}</Text>}
      </span>
      <div
        data-testid="modal-button-container"
        style={{
          paddingTop: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        {buttonText && (
          <Button
            data-testid={buttonTestId}
            onClick={handleClose}
            shape={buttonShape}
          >
            {buttonText}
          </Button>
        )}
        {secondaryButtonText && (
          <Button
            onClick={onSecondaryButtonClick}
            variant="tertiary"
            shape={buttonShape}
          >
            {secondaryButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}
